import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

type Tone = 'neutral' | 'pass' | 'warn' | 'danger' | 'primary' | 'outline';

const TONES: Record<Tone, string> = {
  neutral: 'bg-raised text-muted',
  pass: 'bg-raised text-pass',
  warn: 'bg-raised text-warn',
  danger: 'bg-raised text-danger',
  primary: 'bg-raised text-primary',
  // Declared-but-unconfirmed values are outlined rather than filled (vendor Profile: GoPro H12).
  outline: 'bg-transparent text-primary border border-primary'
};

/** The uppercase mono pill: AVAILABLE, REGISTERED, DEFAULT, EGO, L3. */
export function Badge({
  children,
  tone = 'neutral',
  caps = true,
  className
}: {
  children: ReactNode;
  tone?: Tone;
  /**
   * Status pills (AVAILABLE, REGISTERED) are uppercased here. Capability values are not -
   * the mockups render "LeRobot v2.1", "In-the-wild" and "Aria Gen 2" at their natural case.
   */
  caps?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-[3px] px-2 py-1',
        'font-mono text-[10px] tracking-[0.1em] whitespace-nowrap',
        caps && 'uppercase',
        TONES[tone],
        className
      )}
    >
      {children}
    </span>
  );
}
